import { fetchWithAuth } from "../utils/fetchWithAuth";

//obtener las cuotas de un socio por su rut y año
export const getQuotas = async (rut, year) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/company/${rut}?year=${year}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
    
  } catch (error) {
    console.error("Error fetching quotas:", error);
    throw error;
  }
};

export const getActiveQuotas = async (rut, year) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/active/${rut}?year=${year}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      return {
        error: true,
        message: `Error al obtener cuotas activas: ${response.statusText}`,
      };
    }
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching active quotas:", error);
    throw error;
  }
}

//pago de cuotas
export const payQuota = async (data) => {
  try{
    const response = await fetchWithAuth("/pagos", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) {
      return {
        error: true,
        message: `Error al pagar cuota: ${response.statusText}`,
      };
    }
    
    return await response.json();
  } catch (error) {
    console.error("Error paying quota:", error);
    throw error;
  }
}

// obtener los pagos de las cuotas de un socio por su rut

export const getPaymentsByRut = async (rut) => {
  try {
    const response = await fetchWithAuth(`/pagos/usuario/${rut}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      return {
        error: true,
        message: `Error al obtener pagos: ${response.statusText}`,
      };
    }
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching payments by RUT:", error);
    throw error;
  }
}

// eliminar un pago y revertir el estado de las cuotas sociales
export const deletePayment = async (paymentId) => {
  try {
    const response = await fetchWithAuth(`/pagos/${paymentId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        error: true,
        message: errorData.message || `Error al eliminar pago: ${response.statusText}`,
      };
    }
    
    return {
      success: true,
      message: 'Pago eliminado exitosamente. Las cuotas han vuelto a estado pendiente.',
    };
  } catch (error) {
    console.error("Error deleting payment:", error);
    return {
      error: true,
      message: error.message || 'Error al eliminar el pago',
    };
  }
}

// eliminar una cuota específica de un pago
export const removeQuotaFromPayment = async (socialQuotaId) => {
  try {
    const response = await fetchWithAuth(`/pagos/cuota/${socialQuotaId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        error: true,
        message: errorData.message || `Error al eliminar cuota del pago: ${response.statusText}`,
      };
    }
    
    const data = await response.json();
    return {
      success: true,
      message: data.message || 'Cuota eliminada del pago exitosamente',
      paymentDeleted: data.paymentDeleted || false,
    };
  } catch (error) {
    console.error("Error removing quota from payment:", error);
    return {
      error: true,
      message: error.message || 'Error al eliminar la cuota del pago',
    };
  }
}

export const getAvailableYears = async () => {
  try {
    const response = await fetchWithAuth("/social-quotas/available-years", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      return {
        error: true,
        message: `Error al obtener años disponibles: ${response.statusText}`,
      };
    }
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching available years:", error);
    throw error;
  }
}

export const getBulkLogMails = async (month, year) => {
  try {
    const response = await fetchWithAuth(`/mail/get-bulk-quotas-emails?month=${month}&year=${year}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    
    if (!response.ok) {
      return {
        error: true,
        message: `Error al obtener log de correos: ${response.statusText}`,
      };
    }
    
    return await response.json();
  } catch (error) {
    console.error("Error fetching bulk log emails:", error);
    throw error;
  }
}

export const trySendBulkLogMails = async (month, year) => {
  try {
    const response = await fetchWithAuth(`/mail/retry-failed?month=${month}&year=${year}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al enviar correos: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending bulk log emails:", error);
    throw error;
  }
}

export const updatePeriodicityAndQuotas = async (rut, year, newPeriodicity, newUfAmount, quotas) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/update-periodicity/${rut}/${year}/${newPeriodicity}/${newUfAmount}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quotas }),
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al actualizar periodicidad: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error actualizando periodicidad:", error);
    throw error;
  }
};

export const sendReminderGenericEmail = async (rut) => {
  try {
    const response = await fetchWithAuth("/mail/send-reminder-generic-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ rut }),
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al enviar recordatorio genérico: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error sending reminder generic email:", error);
    throw error;
  }
}

export const updateQuotaAmount = async (quotaId, newAmount) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/${quotaId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ amount: newAmount }),
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al actualizar monto de cuota: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating quota amount:", error);
    throw error;
  }
};

//envio de cuotas sociales get
export const getSocialQuotasSend = async (year, period) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/period/${year}/${period}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al obtener cuotas sociales para enviar: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching social quotas to send:", error);
    throw error;
  }
}

//obtener cuotas confirmadas
export const getSocialQuotasSendConfirmed = async (year, period) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/period/${year}/${period}/confirmed`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al obtener cuotas sociales confirmadas: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching confirmed social quotas:", error);
    throw error;
  }
}

//confirmar cuotas sociales
export const confirmQuotas = async (period,year) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/confirm/${period}/${year}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al confirmar cuotas sociales: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error confirming social quotas:", error);
    throw error;
  }
}

//actualizar monto uf
export const updateUfValue = async (period, year, newUfValue) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/update-uf/${period}/${year}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ newUFValue: Number(newUfValue) }),
    });

    if (!response.ok) {
      return {
        error: true,
        message: `Error al actualizar valor UF: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating UF value:", error);
    throw error;
  }
};

export const healthCheck = async () => {
  try {
    const response = await fetchWithAuth("/webpay/health", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error performing health check:", error);
    throw error;
  }
};


// Obtener valor UF para un período y año específico
export const getUFValueForPeriod = async (period, year) => {
  try {
    const response = await fetchWithAuth(`/social-quotas/uf-value/${period}/${year}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        error: true,
        message: errorData.message || `Error al obtener valor UF: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching UF value:", error);
    return {
      error: true,
      message: error.message || "Error al obtener el valor UF",
    };
  }
};

// Crear cuota manual para una empresa específica
export const createManualQuota = async (companyRut, period, year, ufValue) => {
  try {
    const response = await fetchWithAuth("/social-quotas/create-manual", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_rut: companyRut,
        period: period,
        year: Number(year),
        uf_value: Number(ufValue),
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        error: true,
        message: errorData.message || `Error al crear cuota manual: ${response.statusText}`,
      };
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating manual quota:", error);
    return {
      error: true,
      message: error.message || "Error al crear la cuota manual",
    };
  }
};